type CookieKeys =
  | "sidekick-authorization-token-exp"
  | "sidekick-authorization-token"
  | "sidekick-authorization-user-email"
  | "sidekick-authorization-refresh-token";

const COOKIE_DOMAINS = [".sidekickgpt.io", ".sidekickgpt.dev"];

export class CookieService {
  private static instance: CookieService;

  constructor() {
    return CookieService.instance || (CookieService.instance = this);
  }

  getCookie(cookieName: CookieKeys) {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(";");

    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) === " ") {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }

    return null;
  }

  setCookie(
    cookieName: CookieKeys,
    cookieValue: string,
    expirationDays: number,
  ) {
    const date = new Date();
    date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${cookieName}=${cookieValue};${expires};path=/`;
  }

  deleteCookie(cookieName: CookieKeys) {
    const base = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    document.cookie = base;

    const { hostname } = window.location;
    COOKIE_DOMAINS.filter(
      (domain) => hostname.endsWith(domain) || hostname === domain.slice(1),
    ).forEach((domain) => {
      document.cookie = `${base} domain=${domain};`;
    });
  }

  deleteAllCookies() {
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      this.deleteCookie(name as CookieKeys);
    }
  }

  getAuthTokenStatus() {
    const authTokenExp = this.getCookie("sidekick-authorization-token-exp");
    if (!authTokenExp) return null;
    const today = new Date().getTime();
    const isTokenExpired = today > Number(authTokenExp);
    return isTokenExpired ? "EXPIRED" : "VALID";
  }
}

export const cookieService = Object.freeze(new CookieService());
